// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Default (Light Theme) */
:root {
  --primary-bg: #ffffff;
  --primary-text: #000000;
  --button-bg: #007bff;
  --button-hover-bg: #0056b3;
}

/* Dark Theme */
.dark-theme {
  --primary-bg: #121212;
  --primary-text: #ffffff;
  --button-bg: #1e90ff;
  --button-hover-bg: #4682b4;
}

/* Apply the variables */
body {
  background-color: var(--primary-bg);
  color: var(--primary-text);
}

button {
  background-color: var(--button-bg);
  color: var(--primary-text);
}

.modal-wrapper-btn:hover {
  background: var(--bg-light-hover);
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
html,
li,
p,
ul {
  margin: 0;
  padding: 0
}

li,
ul {
  list-style-type: none
}

a {
  display: inline-block;
  text-decoration: none
}

img {
  max-width: 100%;
  height: auto;
}

.container {
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 20px;
  width: 100%
}

.d-flex {
  display: flex;
  flex-wrap: wrap
}

h1 {
  font-size: 44px;
  font-size: var(--h1-font-size)
}

h1,
h2 {
  color: var(--black-color-font);
  font-weight: 600;
  font-weight: var(--font-weight-600)
}

h2 {
  font-size: 38px;
  font-size: var(--h2-font-size)
}

h3 {
  font-size: 32px;
  font-size: var(--h3-font-size)
}

h3,
h4 {
  color: var(--black-color-font);
  font-weight: 600;
  font-weight: var(--font-weight-600)
}

h4 {
  font-size: 28px;
  font-size: var(--h4-font-size)
}

h5 {
  font-size: 24px;
  font-size: var(--h5-font-size)
}

h5,
h6 {
  color: var(--black-color-font);
  font-weight: 600;
  font-weight: var(--font-weight-600)
}

h6 {
  font-size: 18px;
  font-size: var(--h6-font-size)
}

:where(.css-zuk06n).ant-avatar>img,
img {
  max-width: 100%;
  height: auto;
}

.ant-tooltip-inner {
  pointer-events: none;
}

.ant-tooltip {
  pointer-events: none;
}

.ant-form-item .ant-form-item-label>label {
  font-size: 14px;
  font-weight: 500;
  color: #545454;
}

.ant-input-outlined {
  padding: 8px 15px;
}

/* .ant-btn-primary {
  width: 100%;
  background-color: var(--background-color) !important;
  border-color: var(--background-color) !important;
  text-transform: uppercase;
  box-shadow: none;
  font-weight: 500;
  height: 40px;
} */

.ant-input {
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: var(--bg-white);
  background-image: none;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  transition: all 0.3s;
}

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--background-color) !important;
  border-color: var(--background-color) !important;
}

:where(.css-dev-only-do-not-override-zuk06n).ant-input-outlined:focus,
:where(.css-dev-only-do-not-override-zuk06n).ant-input-outlined:focus-within {
  background-color: transparent;
}

.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:hover,
.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:focus,
.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:focus-within {
  box-shadow: none;
  border-color: var(--background-color) !important;
  background-color: transparent !important;
}

.ant-form-item {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.3;
  list-style: none;
  font-feature-settings: 'tnum';
  margin-bottom: 20px;
  vertical-align: top;

}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7.9px 11px;
  color: #545454;
  font-size: 14px;
  line-height: 1.3;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  transition: all .3s;
}

.ant-modal-wrap {
  background: var(--ant-modal-overlaye);
}

.ant-input::placeholder {
  font-weight: 500;
  padding: 0 10px;
  color: var(--input-placeholder);
}

:where(.css-zuk06n).ant-btn-variant-text:not(:disabled):not(.ant-btn-disabled):hover,
:where(.css-dev-only-do-not-override-zuk06n).ant-btn-variant-text:not(:disabled):not(.ant-btn-disabled):hover {
  color: unset;
  background-color: var(--ant-btn-bg-hover);
}

.anticon-lock svg path,
.anticon-user svg path {
  fill: var(--background-color);
}

.ck.ck-content ul,
.ck.ck-content ol {
  margin-inline: 15px;
  list-style-type: disc;
}

.ck.ck-content ul li {
  list-style-type: disc;
}

.ck.ck-content ol li {
  list-style-type: decimal;
}

.ck.ck-content a {
  color: #646CFF;
}

.ck.ck-powered-by {
  display: none;
}

.fileSize-error {
  color: #ff0000;
  font-size: 12px;

}

.thread .msg-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 75%;
  flex-wrap: wrap;
}

.thread {
  width: 100%;
}

.sidebar.ant-layout-sider .sidebar-categories .sidebar-menu.ant-menu .ant-menu-item.ant-menu-item-selected {
  background: rgba(253, 253, 253, 0.0901960784) !important;
}

.thread .unread-msg-count {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  height: auto;
  border-radius: 8px;
  font-size: 11px;
  line-height: 1.5;
  background: var(--unread-msg-count-bg);
  color: var(--unread-msg-count-color);
  padding: 0px 6px;
  margin-left: auto;
}

.thread .name.highlight {
  font-weight: 600;
  color: #fff;
}

.duplicate-wrapper {
  background: var(--gradient-background);
  height: 100svh;
  justify-content: center;
  padding: 35px 80px 20px;
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  color: var(--white-color);

  .duplicate {
    h1 {
      margin-bottom: 10px;
      color: var(--white-color);

      i {
        color: #ff0000;
      }
    }
  }
}

:where(.css-zuk06n).ant-btn:not(:disabled):focus-visible {
  outline: 3px solid var(--btn-bg-primary);
}

@media screen and (max-width:767px) {

  .ant-tooltip-inner,
  .ant-tooltip {
    pointer-events: none;
    display: none;
  }
}

/* ===== Unified SuperAdmin table styling — matches WeekMate HRMS tables ===== */
.premium-table .ant-table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E8E8E8;
  background: #FFFFFF;
}

.premium-table .ant-table-thead > tr > th {
  background: #F2F5F8;
  color: #313131;
  font-weight: 600;
  font-size: clamp(13px, 0.833vw, 14px);
  padding: 0.75rem 10px;
  border-bottom: 1px solid #E8E8E8;
  white-space: nowrap;
  min-width: 120px;
}

/* Hide antd's column separator bars for the clean HRMS look */
.premium-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.premium-table .ant-table-tbody > tr > td {
  color: #313131;
  background: #FFFFFF;
  font-size: clamp(13px, 0.833vw, 14px);
  border-bottom: 1px solid #E8E8E8;
  padding: 12px 10px;
  height: 54px; /* uniform row height across all tables regardless of content */
  word-break: break-word;
  transition: background 0.2s;
}

.premium-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

.premium-table .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #F8FAFC !important;
}

/* Compact the checkbox/selection column so min-width:120px doesn't bloat it (matches HRMS) */
.premium-table .ant-table-thead > tr > th.ant-table-selection-column,
.premium-table .ant-table-tbody > tr > td.ant-table-selection-column,
.premium-table .ant-table-thead > tr > th:first-child:has(.ant-checkbox),
.premium-table .ant-table-tbody > tr > td:has(.ant-checkbox-wrapper) {
  min-width: unset;
  max-width: 60px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;aACW;AACb;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;;;;;;;;EAWE,SAAS;EACT;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;EACpD,gDAAgD;AAClD;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,gBAAgB;EAChB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;;EAEzB;IACE;MACE,mBAAmB;MACnB,yBAAyB;;MAEzB;QACE,cAAc;MAChB;IACF;EACF;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE;;IAEE,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,YAAY,EAAE,+DAA+D;EAC7E,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6FAA6F;AAC7F;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Default (Light Theme) */\n:root {\n  --primary-bg: #ffffff;\n  --primary-text: #000000;\n  --button-bg: #007bff;\n  --button-hover-bg: #0056b3;\n}\n\n/* Dark Theme */\n.dark-theme {\n  --primary-bg: #121212;\n  --primary-text: #ffffff;\n  --button-bg: #1e90ff;\n  --button-hover-bg: #4682b4;\n}\n\n/* Apply the variables */\nbody {\n  background-color: var(--primary-bg);\n  color: var(--primary-text);\n}\n\nbutton {\n  background-color: var(--button-bg);\n  color: var(--primary-text);\n}\n\n.modal-wrapper-btn:hover {\n  background: var(--bg-light-hover);\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhtml,\nli,\np,\nul {\n  margin: 0;\n  padding: 0\n}\n\nli,\nul {\n  list-style-type: none\n}\n\na {\n  display: inline-block;\n  text-decoration: none\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.container {\n  margin: 0 auto;\n  max-width: 1440px;\n  padding: 0 20px;\n  width: 100%\n}\n\n.d-flex {\n  display: flex;\n  flex-wrap: wrap\n}\n\nh1 {\n  font-size: 44px;\n  font-size: var(--h1-font-size)\n}\n\nh1,\nh2 {\n  color: var(--black-color-font);\n  font-weight: 600;\n  font-weight: var(--font-weight-600)\n}\n\nh2 {\n  font-size: 38px;\n  font-size: var(--h2-font-size)\n}\n\nh3 {\n  font-size: 32px;\n  font-size: var(--h3-font-size)\n}\n\nh3,\nh4 {\n  color: var(--black-color-font);\n  font-weight: 600;\n  font-weight: var(--font-weight-600)\n}\n\nh4 {\n  font-size: 28px;\n  font-size: var(--h4-font-size)\n}\n\nh5 {\n  font-size: 24px;\n  font-size: var(--h5-font-size)\n}\n\nh5,\nh6 {\n  color: var(--black-color-font);\n  font-weight: 600;\n  font-weight: var(--font-weight-600)\n}\n\nh6 {\n  font-size: 18px;\n  font-size: var(--h6-font-size)\n}\n\n:where(.css-zuk06n).ant-avatar>img,\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.ant-tooltip-inner {\n  pointer-events: none;\n}\n\n.ant-tooltip {\n  pointer-events: none;\n}\n\n.ant-form-item .ant-form-item-label>label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #545454;\n}\n\n.ant-input-outlined {\n  padding: 8px 15px;\n}\n\n/* .ant-btn-primary {\n  width: 100%;\n  background-color: var(--background-color) !important;\n  border-color: var(--background-color) !important;\n  text-transform: uppercase;\n  box-shadow: none;\n  font-weight: 500;\n  height: 40px;\n} */\n\n.ant-input {\n  margin: 0;\n  padding: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: var(--bg-white);\n  background-image: none;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  transition: all 0.3s;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--background-color) !important;\n  border-color: var(--background-color) !important;\n}\n\n:where(.css-dev-only-do-not-override-zuk06n).ant-input-outlined:focus,\n:where(.css-dev-only-do-not-override-zuk06n).ant-input-outlined:focus-within {\n  background-color: transparent;\n}\n\n.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:hover,\n.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:focus,\n.ant-form-item :where(.css-dev-only-do-not-override-15yfeql).ant-input-outlined:focus-within {\n  box-shadow: none;\n  border-color: var(--background-color) !important;\n  background-color: transparent !important;\n}\n\n.ant-form-item {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #545454;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.3;\n  list-style: none;\n  font-feature-settings: 'tnum';\n  margin-bottom: 20px;\n  vertical-align: top;\n\n}\n\n.ant-input {\n  box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  font-feature-settings: \"tnum\";\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: 7.9px 11px;\n  color: #545454;\n  font-size: 14px;\n  line-height: 1.3;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  transition: all .3s;\n}\n\n.ant-modal-wrap {\n  background: var(--ant-modal-overlaye);\n}\n\n.ant-input::placeholder {\n  font-weight: 500;\n  padding: 0 10px;\n  color: var(--input-placeholder);\n}\n\n:where(.css-zuk06n).ant-btn-variant-text:not(:disabled):not(.ant-btn-disabled):hover,\n:where(.css-dev-only-do-not-override-zuk06n).ant-btn-variant-text:not(:disabled):not(.ant-btn-disabled):hover {\n  color: unset;\n  background-color: var(--ant-btn-bg-hover);\n}\n\n.anticon-lock svg path,\n.anticon-user svg path {\n  fill: var(--background-color);\n}\n\n.ck.ck-content ul,\n.ck.ck-content ol {\n  margin-inline: 15px;\n  list-style-type: disc;\n}\n\n.ck.ck-content ul li {\n  list-style-type: disc;\n}\n\n.ck.ck-content ol li {\n  list-style-type: decimal;\n}\n\n.ck.ck-content a {\n  color: #646CFF;\n}\n\n.ck.ck-powered-by {\n  display: none;\n}\n\n.fileSize-error {\n  color: #ff0000;\n  font-size: 12px;\n\n}\n\n.thread .msg-wrapper {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  max-width: 75%;\n  flex-wrap: wrap;\n}\n\n.thread {\n  width: 100%;\n}\n\n.sidebar.ant-layout-sider .sidebar-categories .sidebar-menu.ant-menu .ant-menu-item.ant-menu-item-selected {\n  background: rgba(253, 253, 253, 0.0901960784) !important;\n}\n\n.thread .unread-msg-count {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  height: auto;\n  border-radius: 8px;\n  font-size: 11px;\n  line-height: 1.5;\n  background: var(--unread-msg-count-bg);\n  color: var(--unread-msg-count-color);\n  padding: 0px 6px;\n  margin-left: auto;\n}\n\n.thread .name.highlight {\n  font-weight: 600;\n  color: #fff;\n}\n\n.duplicate-wrapper {\n  background: var(--gradient-background);\n  height: 100svh;\n  justify-content: center;\n  padding: 35px 80px 20px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  flex-direction: column;\n  color: var(--white-color);\n\n  .duplicate {\n    h1 {\n      margin-bottom: 10px;\n      color: var(--white-color);\n\n      i {\n        color: #ff0000;\n      }\n    }\n  }\n}\n\n:where(.css-zuk06n).ant-btn:not(:disabled):focus-visible {\n  outline: 3px solid var(--btn-bg-primary);\n}\n\n@media screen and (max-width:767px) {\n\n  .ant-tooltip-inner,\n  .ant-tooltip {\n    pointer-events: none;\n    display: none;\n  }\n}\n\n/* ===== Unified SuperAdmin table styling — matches WeekMate HRMS tables ===== */\n.premium-table .ant-table {\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #E8E8E8;\n  background: #FFFFFF;\n}\n\n.premium-table .ant-table-thead > tr > th {\n  background: #F2F5F8;\n  color: #313131;\n  font-weight: 600;\n  font-size: clamp(13px, 0.833vw, 14px);\n  padding: 0.75rem 10px;\n  border-bottom: 1px solid #E8E8E8;\n  white-space: nowrap;\n  min-width: 120px;\n}\n\n/* Hide antd's column separator bars for the clean HRMS look */\n.premium-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.premium-table .ant-table-tbody > tr > td {\n  color: #313131;\n  background: #FFFFFF;\n  font-size: clamp(13px, 0.833vw, 14px);\n  border-bottom: 1px solid #E8E8E8;\n  padding: 12px 10px;\n  height: 54px; /* uniform row height across all tables regardless of content */\n  word-break: break-word;\n  transition: background 0.2s;\n}\n\n.premium-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n.premium-table .ant-table-tbody > tr.ant-table-row:hover > td {\n  background: #F8FAFC !important;\n}\n\n/* Compact the checkbox/selection column so min-width:120px doesn't bloat it (matches HRMS) */\n.premium-table .ant-table-thead > tr > th.ant-table-selection-column,\n.premium-table .ant-table-tbody > tr > td.ant-table-selection-column,\n.premium-table .ant-table-thead > tr > th:first-child:has(.ant-checkbox),\n.premium-table .ant-table-tbody > tr > td:has(.ant-checkbox-wrapper) {\n  min-width: unset;\n  max-width: 60px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
